import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import Antd from 'ant-design-vue';
import Axios from 'axios';
Vue.config.productionTip = false;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'ant-design-vue/dist/antd.css';
import Qs from 'qs'
import {Tab, Tabs} from 'vant';
import animated from 'animate.css' // npm install animate.css --save安装，再引入
let baseUrls = ''
if (process.env.NODE_ENV =='development') {
  // 开发环境的url
  baseUrls = '/'
} else if (process.env.NODE_ENV == 'production') {
  // 正式环境的 request url
  baseUrls = 'https://kyxapi.zkshare.com/'
}
axios.defaults.baseURL =baseUrls
// axios.defaults.headers['accept'] = 'text/plain';
Vue.prototype.$http = Axios; 
Vue.prototype.$qs=Qs;
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
Vue.use(ElementUI);
Vue.use(animated)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Antd)
router.beforeEach((to,from,next)=>{
	if(to.meta.title){
		document.title = to.meta.title
	}
	next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
